import React from "react";
import SVG, { SVGProps } from "./SVG";

const AddIcon: React.FunctionComponent<SVGProps> = props => (
  <SVG {...props}>
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
  </SVG>
);

export default AddIcon;
